import { SPage } from 'servisofts-component2';

import root from "./root";
import Test from './Test';
import Carga from './Carga';
import perfil from './perfil';
// import sucursal from './sucursal';
// import tutoriales from './tutoriales';
// import inversiones from './inversiones';
// import ranking from './ranking';
import login from './login';
// import servicio from './servicio';
// import paquete from './paquete';
// import publicacion from './publicacion';
// import notifications from './notifications';
// import notification from './notification';
import terminos from './terminos';
import permisos from './permisos';
import permiso from './permiso';
import InfoExpedicion from './root/InfoExpedicion';
import check from './check';
import Test2 from './Test2';
import Test3 from './Test3';
import admin from './admin';
import checklist from './checklist';
// import registro from './registro';
// import cuenta from './cuenta';

export default SPage.combinePages("/", {
  "": Carga,
  // "":Test,
  "test": Test,
  "test2": Test2,
  "test3": Test3,
  "root": root,
  permisos,
  ...perfil,
  // ...sucursal,
  // ...tutoriales,
  // inversiones,
  // ...ranking,
  ...login,
  ...check,
  ...checklist,
  ...admin,
  // ...servicio,
  // ...paquete,
  // ...publicacion,
  // ...notifications,
  // ...notification,
  // ...registro,
  // ...cuenta,
  "terminos": terminos,
  "infoexpedicion": InfoExpedicion,
  ...permiso,

 });